module.exports = __webpack_public_path__ + "static/favicon-0a9bb463aa0532d34b64227654107b7e.ico";